// Rasensamen Aufwandmengen-Rechner — rasenwelt.de
// Asset file: seed-calculator.js

(function () {

  // ── Modal trigger link ────────────────────────────────────────────────────
  var trigger = document.getElementById('rw-calc-trigger');
  var modal = document.getElementById('rw-calc-modal');
  var overlay = document.getElementById('rw-calc-overlay');
  var closeBtn = document.getElementById('rw-calc-close');

  if (!trigger || !modal) return;

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    modal.classList.add('rw-modal-open');
    overlay.classList.add('rw-modal-open');
    document.body.style.overflow = 'hidden';
  });

  function closeModal() {
    modal.classList.remove('rw-modal-open');
    overlay.classList.remove('rw-modal-open');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // ── Calculator ────────────────────────────────────────────────────────────
  var wrap = document.getElementById('rw-seed-calc');
  if (!wrap) return;

  var rate = parseInt(wrap.dataset.rate) || 30;

  wrap.innerHTML = [
    '<div class="rw-calc-header">',
      '<span style="font-size:16px;line-height:1;">🌱</span>',
      '<div>',
        '<div class="rw-calc-title">Aufwandmenge berechnen</div>',
        '<div class="rw-calc-sub">Wie viel Rasensamen brauche ich?</div>',
      '</div>',
    '</div>',
    '<div class="rw-calc-body">',
      '<div class="rw-toggle-section">',
        '<div class="rw-field-label">Anwendungsart</div>',
        '<div class="rw-toggle-group">',
          '<button class="rw-toggle-btn rw-active" data-mode="new">Neuanlage<br><small>' + rate + ' g/m²</small></button>',
          '<button class="rw-toggle-btn" data-mode="over">Nachsaat<br><small>' + Math.round(rate * 0.66) + ' g/m²</small></button>',
        '</div>',
      '</div>',
      '<div class="rw-input-section">',
        '<div class="rw-field-label">Rasenfläche</div>',
        '<div class="rw-input-row">',
          '<div class="rw-slider-wrap">',
            '<input class="rw-slider" type="range" id="rwSlider" min="10" max="2000" value="100" step="10">',
          '</div>',
          '<div class="rw-num-wrap">',
            '<input type="number" id="rwInput" value="100" min="1" max="99999">',
          '</div>',
        '</div>',
      '</div>',
      '<div class="rw-divider"></div>',
      '<div class="rw-results-row">',
        '<div class="rw-result-pill rw-accent">',
          '<div class="rw-result-label">Benötigt</div>',
          '<div class="rw-result-value" id="rwKg">3.0</div>',
          '<div class="rw-result-unit">Kilogramm</div>',
        '</div>',
        '<div class="rw-result-pill">',
          '<div class="rw-result-label">Entspricht</div>',
          '<div class="rw-result-value" id="rwBag">1×</div>',
          '<div class="rw-result-unit" id="rwBagUnit">3 kg Gebinde</div>',
        '</div>',
      '</div>',
      '<div class="rw-bag-rec">',
        '<span style="font-size:14px;margin-top:1px;">📦</span>',
        '<div class="rw-bag-text" id="rwRec">Empfehlung: <strong>1× 3 kg Gebinde</strong> — reicht genau für deine Fläche.</div>',
      '</div>',
      '<div class="rw-rate-info">Aufwandmenge: <b id="rwRate">' + rate + ' g/m²</b> · gerundet auf 0,5 kg</div>',
    '</div>'
  ].join('');

  var activeRate = rate;

  wrap.querySelectorAll('.rw-toggle-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      wrap.querySelectorAll('.rw-toggle-btn').forEach(function (b) { b.classList.remove('rw-active'); });
      btn.classList.add('rw-active');
      activeRate = btn.dataset.mode === 'new' ? rate : Math.round(rate * 0.66);
      document.getElementById('rwRate').textContent = activeRate + ' g/m²';
      rwCalc();
    });
  });

  document.getElementById('rwSlider').addEventListener('input', function () {
    document.getElementById('rwInput').value = this.value;
    rwCalc();
  });

  document.getElementById('rwInput').addEventListener('input', function () {
    var v = Math.min(parseInt(this.value) || 0, 99999);
    document.getElementById('rwSlider').value = Math.min(v, 2000);
    rwCalc();
  });

  function rwCalc() {
    var area = parseInt(document.getElementById('rwInput').value) || 0;
    var kg = Math.ceil((area * activeRate / 1000) * 2) / 2;
    var bagDisplay, bagUnit, rec;

    if (kg <= 3) {
      bagDisplay = '1×'; bagUnit = '3 kg Gebinde';
      rec = 'Empfehlung: <strong>1× 3 kg Gebinde</strong> — reicht genau für deine Fläche.';
    } else if (kg <= 6) {
      var n = Math.ceil(kg / 3);
      bagDisplay = n + '×'; bagUnit = '3 kg Gebinde';
      rec = 'Empfehlung: <strong>' + n + '× 3 kg Gebinde</strong> — optimal für deine Fläche.';
    } else if (kg <= 10) {
      bagDisplay = '1×'; bagUnit = '10 kg Gebinde';
      rec = 'Empfehlung: <strong>1× 10 kg Gebinde</strong> — günstiger als mehrere 3 kg Gebinde.';
    } else {
      var f = Math.floor(kg / 10), r = kg % 10;
      if (r === 0) {
        bagDisplay = f + '×'; bagUnit = '10 kg Gebinde';
        rec = 'Empfehlung: <strong>' + f + '× 10 kg Gebinde</strong>';
      } else if (r <= 3) {
        bagDisplay = f + '×'; bagUnit = '10 kg + 1× 3 kg';
        rec = 'Empfehlung: <strong>' + f + '× 10 kg</strong> + <strong>1× 3 kg Gebinde</strong>';
      } else {
        var e = Math.ceil(r / 3);
        bagDisplay = f + '×'; bagUnit = '10 kg + ' + e + '× 3 kg';
        rec = 'Empfehlung: <strong>' + f + '× 10 kg</strong> + <strong>' + e + '× 3 kg Gebinde</strong>';
      }
    }

    document.getElementById('rwKg').textContent = kg.toFixed(1);
    document.getElementById('rwBag').textContent = bagDisplay;
    document.getElementById('rwBagUnit').textContent = bagUnit;
    document.getElementById('rwRec').innerHTML = rec;
  }

  rwCalc();

})();
